import React, { useEffect, useState } from 'react';
import {
  Button,
  Form,
  FormContent,
  InputNumber,
  message,
  Select,
  SubContent,
  Wrapper,
  useBreadcrumbRoutes,
} from '@maxtropy/components';
import { Col, Row, Space, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  apiV2ReportConfigDetailPost,
  apiV2ReportConfigSavePost,
  apiV2RuleRuleListPost,
} from '@maxtropy/device-customer-apis-v2';
type FormValues = {
  longWaterFlowThreshold?: number;
  lossRateThreshold?: number;
  gasAlarmRuleIds?: number[];
};

const routes = [{ name: '配置' }];

const EnergyReportConfig: React.FC = () => {
  const navigate = useNavigate();
  const breadcrumbRoutes = useBreadcrumbRoutes();
  const [form] = Form.useForm<FormValues>();
  const [pageLoading, setPageLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [ruleOptions, setRuleOptions] = useState<{ label: string; value: number }[]>([]);

  useEffect(() => {
    setPageLoading(true);
    apiV2ReportConfigDetailPost({})
      .then(detailRes => {
        form.setFieldsValue(detailRes);
        return apiV2RuleRuleListPost({});
      })
      .then(ruleRes => {
        setRuleOptions(
          (ruleRes.list ?? [])
            .filter(item => item.id !== undefined)
            .map(item => ({
              label: item.name || item.code || String(item.id),
              value: item.id!,
            }))
        );
      })
      .finally(() => setPageLoading(false));
  }, [form]);

  const handleSave = () => {
    form.validateFields().then(values => {
      setSaveLoading(true);
      apiV2ReportConfigSavePost(values)
        .then(() => message.success('保存成功'))
        .finally(() => setSaveLoading(false));
    });
  };

  return (
    <Wrapper routes={[...(breadcrumbRoutes?.routes ?? []), ...routes]}>
      <Spin spinning={pageLoading || saveLoading}>
        <Form form={form}>
          <FormContent narrow title="配置">
            <SubContent title="用水分析">
              <Row>
                <Col span={24}>
                  <Form.Item label="长流水判断流量" name="longWaterFlowThreshold">
                    <InputNumber
                      min={0}
                      precision={2}
                      placeholder="请输入"
                      style={{ width: '100%' }}
                      controls={false}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="偏差率" name="lossRateThreshold">
                    <InputNumber
                      min={0}
                      precision={2}
                      placeholder="请输入"
                      style={{ width: '100%' }}
                      controls={false}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </SubContent>

            <SubContent title="用气分析">
              <Row>
                <Col span={24}>
                  <Form.Item label="阀门泄露报警规则" name="gasAlarmRuleIds">
                    <Select
                      mode="multiple"
                      options={ruleOptions}
                      placeholder="请选择"
                      showSearch
                      allowClear
                      optionFilterProp="label"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </SubContent>
          </FormContent>

          <Space className="sticky-footer" size={8}>
            <Button type="primary" loading={saveLoading} onClick={handleSave}>
              保存
            </Button>
            <Button onClick={() => navigate('/energy/report/dayAndMonthly')}>返回</Button>
          </Space>
        </Form>
      </Spin>
    </Wrapper>
  );
};

export default EnergyReportConfig;
